<!--suppress HtmlFormInputWithoutLabel -->
<template>
  <FormField
    :identifier="identifier"
    :label="label"
    :disabled="disabled"
    :has-info="hasInfo"
    :is-mandatory="isMandatory"
    :validation-error="validationError"
    :label-is-path="labelIsPath"
    v-on:info-click="infoClick()"
  >
    <slot name="icon"></slot>
    <slot>
      <select
        :name="identifier"
        :id="identifier"
        v-model="model"
        :disabled="disabled"
      >
        <option v-for="option in options" :value="option.value">{{ option.label }}</option>
      </select>
    </slot>
  </FormField>
</template>

<script>
import Translation from '@/components/i18n/Translation.vue';
import TranslationSource from '@/types/i18n/TranslationSource';
import FormField from '@/components/form/FormField.vue';
import { ValidationError } from 'class-validator';

export default {
  components: {
    Translation,
    FormField
  },
  props: {
    value: {
      type: [String, Number]
    },
    identifier: String,
    label: String,
    labelIsPath: {
      type: Boolean,
      default: true
    },
    hasInfo: Boolean,
    isMandatory: Boolean,
    disabled: {
      type: Boolean,
      default: false
    },
    options: {
      type: Array
    },
    validationError: {
      type: [Object, null]
    }
  },
  methods: {
    infoClick() {
      this.$emit('info-click')
    }
  },
  computed: {
    model: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      }
    }
  }
}
</script>
